export default "__VITE_ASSET__DZWjgYdA__"